// typecheck: ignore file
import {
  BankAccount,
  IdentityVerification,
  RequestBankAccountConfirmation,
} from 'payments/constants/CopyConstants';
import ActivityActions from 'payments/actions/ActivityActions';
import ActivityStore from 'payments/stores/ActivityStore';
import AddBankAccountFormContainer from './AddBankAccountFormContainer.jsx';
import Button from 'components/Button.jsx';
import Carousel from 'components/Carousel.jsx';
import CarouselPage from 'components/CarouselPage.jsx';
import chainOnEnter from 'components/mixins/chainOnEnter';
import Container from 'components/Container.jsx';
import cx from 'classnames';
import DepositConfirmation from 'payments/components/DepositConfirmation.jsx';
import DepositSetupReceipt from './DepositSetupReceipt.jsx';
import DepositSetupViewHeader from './DepositSetupViewHeader.jsx';
import EventTrackingConstants from 'payments/constants/EventTrackingConstants';
import Glyph from 'components/Glyph.jsx';
import IdentityVerificationView from './IdentityVerificationView.jsx';
import Link from 'components/Link.jsx';
import PaymentAccountStore from './../stores/PaymentAccountStore';
import React from 'react';
import RequirePaymentAccount from 'components/mixins/RequirePaymentAccount';
import RequireUser from 'components/mixins/RequireUser';
import TitleHeader from 'components/TitleHeader.jsx';
import ToastActions from 'actions/ToastActions';
import trackView from 'lib/trackView';

import './styles/DepositSetupView.scss';

const RequireVerification = {
  statics: {
    onEnter(nextState: RouterState, replaceWith: (location: LocationDescriptor) => void, callback: Function) {
      const account = PaymentAccountStore.getPaymentAccount();

      const needVerification = (
        account.needBasicVerification() ||
        account.needBankAccountVerification()
      );

      if (!needVerification) {
        replaceWith('/campaigns');
      }

      callback();
    },
  },
};

/* Check the store for the payment request id in the query
 * param, if not there than try to load it.
 */
const RequireActivity = {
  statics: {
    onEnter(nextState: RouterState, replaceWith: (location: LocationDescriptor) => void, callback: Function) {
      const { query } = nextState.location;
      if (!query.req) {
        ToastActions.showDefaultErrorToast();
        replaceWith('/campaigns');
        callback();
        return;
      }

      const activity = ActivityStore.getActivityById(query.req);
      if (activity) {
        callback();
        return;
      }

      ActivityActions.loadByUuid(query.req).then(() => callback(), () => {
        ToastActions.showDefaultErrorToast();
        replaceWith('/campaigns');
        callback();
      });
    },
  },
};

const DepositSetupViewCarouselPage = props =>
  <CarouselPage eventScreenName={props.eventScreenName}>
    <Container size="medium">
      {props.children}
    </Container>
  </CarouselPage>;

DepositSetupViewCarouselPage.propTypes = {
  eventScreenName: React.PropTypes.string,
};

const DepositSetupView = React.createClass({
  propTypes: {
    location: React.PropTypes.object.isRequired,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  mixins: [
    chainOnEnter([
      RequireUser,
      RequirePaymentAccount,
      RequireVerification,
      RequireActivity,
    ]),
  ],

  getInitialState() {
    const account = PaymentAccountStore.getPaymentAccount();
    let activity;
    let initialIndex;
    const { req } = this.props.location.query;
    if (req) {
      activity = ActivityStore.getActivityById(req);
    }

    if (account.needBasicVerification()) {
      initialIndex = 0;
    } else if (account.needBankAccountVerification()) {
      initialIndex = 1;
    }

    return { initialIndex, account, activity };
  },

  onClose() {
    if (!this.context.router.goBack()) {
      this.context.router.push('/campaigns');
    }
  },

  render() {
    const needBankAccount = this.state.account.needBankAccountVerification();
    const progressLabels = needBankAccount ?
      ['verify identify', 'add bank account', 'review & confirm'] :
      ['verify identify', 'review & confirm'];

    return (
      <div className={cx('DepositSetupView', this.props.className)}>
        <Link
          color="thunder"
          className="DepositSetupView-closeButton"
          onClick={this.onClose}
          eventElementName="DepositSetupView-closeButton">
          <Glyph name="close" size="xlarge" solo />
        </Link>
        <Container>
          <Carousel
            ref={ref => (this._carousel = ref)}
            initialIndex={this.state.initialIndex}
            clickablePageControls={false}
            progressLabels={progressLabels}>
            <DepositSetupViewCarouselPage
              key={EventTrackingConstants.CREATE_DEPOSIT_ADDRESS}
              eventScreenName={EventTrackingConstants.CREATE_DEPOSIT_ADDRESS}>
              <DepositSetupViewHeader
                title={IdentityVerification.title}
                subtext={IdentityVerification.subtext}
              />
              <IdentityVerificationView onVerified={() => this._carousel.next()} />
            </DepositSetupViewCarouselPage>

            {needBankAccount &&
              <DepositSetupViewCarouselPage
                key={EventTrackingConstants.CREATE_DEPOSIT_ACCOUNT}
                eventScreenName={EventTrackingConstants.CREATE_DEPOSIT_ACCOUNT}>
                {this.state.requestedSchoolAccount &&
                  <div>
                    <TitleHeader
                      title={RequestBankAccountConfirmation.title}
                      subtext={RequestBankAccountConfirmation.subtext}
                      image={require('assets/images/payments/admin-request-sent.svg')}
                      size="large"
                      subtle
                    />
                    <Button onClick={() => this.context.router.push('/settings/transactions/')}>
                      Got it
                    </Button>
                  </div>
                }

                {!this.state.requestedSchoolAccount &&
                  <div>
                    <DepositSetupViewHeader
                      title={BankAccount.title}
                      subtext={BankAccount.subtext}
                    />
                    <AddBankAccountFormContainer
                      onSchoolBankAccountAdded={() => this.setState({ requestedSchoolAccount: true })}
                      onBankAccountAdded={() => this._carousel.next()}
                    />
                  </div>
                }
              </DepositSetupViewCarouselPage>
            }

            <DepositSetupViewCarouselPage
              key={EventTrackingConstants.CONFIRM_DEPOSIT}
              eventScreenName={EventTrackingConstants.CONFIRM_DEPOSIT}>
              <DepositSetupReceipt
                activity={this.state.activity}
                onDepositCompleted={() => this._carousel.next()}
              />
            </DepositSetupViewCarouselPage>
            <DepositSetupViewCarouselPage
              key={EventTrackingConstants.DEPOSIT_RECEIPT}
              eventScreenName={EventTrackingConstants.DEPOSIT_RECEIPT}>
              <DepositConfirmation
                onCompleteText="Return to your wallet"
                onComplete={() => this.context.router.push('/campaigns')}
              />
            </DepositSetupViewCarouselPage>
          </Carousel>
        </Container>
      </div>
    );
  },
});

export default trackView(DepositSetupView);



// WEBPACK FOOTER //
// ./src/payments/components/DepositSetupView.jsx